import { Box } from "@mui/material";
import { useEditorContext } from "features/editor/context/editor";

export const Original = () => {
  const { list, activeItemIndex } = useEditorContext();
  const { text } = list.items[activeItemIndex!]?.original ?? {};

  if (!text) {
    return <Box sx={{ mb: 1.5 }}>There is no original text for selected item.</Box>;
  }

  return <textarea value={text} onChange={() => {}} style={{ width: "100%", height: "100%", padding: "6px 10px" }} />;
};
